export default {
  panels: [
    {
      index: 0,
      name: 1,
      paperType: 'A4',
      height: 297,
      width: 210,
      paperHeader: 42,
      paperFooter: 792,
      printElements: [],
      paperNumberContinue: true,
      paperNumberLeft: 284,
      paperNumberTop: 808.5,
      watermarkOptions: {},
      panelLayoutOptions: {},
    },
  ],
}
